import {
  REQUEST_SENSORS,
  RESPONSE_SENSORS,
  REQUEST_SENSORS_FAILURE,
  CLEAR_SENSORS,
  SET_SENSORS_DATA_READY,
  SET_SENSORS_DATA_EMPTY
} from './../actions/sensorsActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: {},
  errors: {},
  isDataReady: false
}

const sensorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENSORS:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case RESPONSE_SENSORS:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          data: action.data,
          errors: {}
        }
      )
    case REQUEST_SENSORS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    case CLEAR_SENSORS:
      return Object.assign(
        {},
        state,
        initialState
      )
    case SET_SENSORS_DATA_READY:
      return Object.assign(
        {},
        state,
        {
          isDataReady: true
        }
      )
    case SET_SENSORS_DATA_EMPTY:
      return Object.assign(
        {},
        state,
        {
          isDataReady: false
        }
      )
    default:
      return state
  }
}

export default sensorsReducer